import * as React from "react";
import { Accordion } from "../../../react-core/Html/Accordion";
import { FooterContents } from "../Resoures/Contents";

export const SecuredFooter = () => {
    const [providerLinkExpanded, setProviderLinkExpanded] = React.useState<boolean>(false);
    return (
        <footer className="footer no-print">
            <ul className="footer-links">
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenadviser.com/en-gb/wrap/platform-help-centre"
                        role="link"
                    >
                        Help and guides
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenadviser.com/en-gb/wrap/contact"
                        role="link"
                    >
                        Contact us
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenplc.com/en-gb/cookie-policy"
                        role="link"
                    >
                        Cookie policy
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenadviser.com/en-gb/privacy"
                        role="link"
                    >
                        Privacy policy
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenadviser.com/en-gb/legal"
                        role="link"
                    >
                        Legal information
                    </a>
                </li>
                <li>
                    {" "}
                    <a
                        className="hyperlink"
                        target="_blank"
                        href="https://www.aberdeenadviser.com/en-gb/accessibility"
                        role="link"
                    >
                        Accessibility
                    </a>
                </li>
            </ul>
            <div className="row">
                <Accordion label={FooterContents.WebsiteBrandAndProviderDetails} cssWrapper={"accordion-simple"}>
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="footer-content">
                                <p>{FooterContents.ProviderDetailsParagraph}</p>
                                <p>
                                    {FooterContents.ProviderDetailsParagraph4}
                                    <a className="hyperlink" target="_blank" href="https://www.aberdeenplc.com">
                                        {FooterContents.ProviderDetailsParagraph4Link}
                                    </a>
                                </p>
                                <p>{FooterContents.ProviderDetailsParagraph5}</p>
                            </div>
                        </div>
                    </div>
                </Accordion>
            </div>
        </footer>
    );
};
